var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cesiumContainer"}},[_c('map-compass',{attrs:{"sceneBool":_vm.sceneBool}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }